<template>
  <div class="payresult-page">
    <header class="result-header">
      <van-icon name="arrow-left" class="back-icon" @click="goHome" />
      <span>支付结果</span>
    </header>

    <div class="result-body">
      <div class="result-icon" :class="iconClass">
        <van-icon :name="iconName" />
      </div>
      <div class="result-text">{{ statusText }}</div>
      <div class="result-hint" v-if="status === 'polling'">正在确认支付结果，请稍候...</div>
      <div class="result-hint" v-if="status === 'success'">可前往客户列表为客户预约体检</div>
      <div class="result-hint" v-if="status === 'fail'">如已扣款，请联系客服确认</div>

      <div class="result-btns">
        <div class="btn-ghost" @click="goHome">返回工作台</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getSanGaoCustomerList } from "@/api/sanGao";

export default {
  name: "SanGaoSalesmanPayResult",
  data() {
    return {
      memberId: null,
      pollCount: 0,
      maxPoll: 6,
      timer: null,
      status: "polling",
    };
  },
  computed: {
    iconClass() {
      return {
        polling: "is-polling",
        success: "is-success",
        fail: "is-fail",
      }[this.status];
    },
    iconName() {
      return {
        polling: "loading",
        success: "checked",
        fail: "close",
      }[this.status];
    },
    statusText() {
      return {
        polling: "支付确认中",
        success: "支付成功",
        fail: "支付未完成",
      }[this.status];
    },
  },
  created() {
    this.memberId = this.$route.query.memberId;
    this.startPoll();
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    startPoll() {
      this.poll();
    },
    poll() {
      this.pollCount++;
      getSanGaoCustomerList({})
        .then((res) => {
          if (res && res.code === 200 && Array.isArray(res.data)) {
            const target = res.data.find((c) => String(c.id) === String(this.memberId));
            if (target && target.auditStatus === 3) {
              this.status = "success";
              return;
            }
          }
          this.scheduleNext();
        })
        .catch(() => {
          this.scheduleNext();
        });
    },
    scheduleNext() {
      if (this.pollCount < this.maxPoll) {
        this.timer = setTimeout(() => this.poll(), 3000);
      } else {
        this.status = "fail";
      }
    },
    goHome() {
      this.$router.replace({
        path: "/sanGao/salesman/index",
        query: this.$route.query.orgId ? { orgId: this.$route.query.orgId } : {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.payresult-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #0874ca 0%, #4ba8e0 18%, #dff6ff 40%, #f4fafd 100%);
}

.result-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 14px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(180deg, #0874ca, #2a94dd);

  .back-icon {
    position: absolute;
    left: 14px;
    font-size: 20px;
  }
}

.result-body {
  padding: 60px 20px 40px;
  text-align: center;
}

.result-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

  &.is-polling {
    background: linear-gradient(135deg, #409eff, #337ecc);
    animation: pulse 1.5s ease-in-out infinite;
  }
  &.is-success {
    background: linear-gradient(135deg, #52c41a, #3da012);
  }
  &.is-fail {
    background: linear-gradient(135deg, #b0a89e, #999);
  }
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 8px 24px rgba(64, 158, 255, 0.2); }
  50% { box-shadow: 0 8px 36px rgba(64, 158, 255, 0.4); }
}

.result-text {
  font-size: 20px;
  font-weight: 600;
  color: #163b5c;
  margin-bottom: 8px;
}

.result-hint {
  font-size: 13px;
  color: #7c8d9c;
  margin-top: 6px;
}

.result-btns {
  margin-top: 36px;
  display: flex;
  justify-content: center;
}

.btn-ghost {
  width: 60%;
  height: 44px;
  line-height: 44px;
  border: 1px solid #168de0;
  color: #168de0;
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.btn-ghost:active {
  background: rgba(22, 141, 224, 0.05);
}
</style>
